
let selectedDoor = null;
let doors = [];
const INSERTS = ['gyprock', 'mirror', 'paintedglass'];
const VINYL_OPTIONS = ['glacier', 'chalk', 'whitebirch', 'buff', 'cameo', 'shadow'];
const COLONIAL_OPTIONS = ['buckingham', 'rochester', 'sandringham', 'cromwell', 'hastings', 'vj'];
let isDoorTouched = false;


class SelectedDoorOptionSelector extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            Array.from(document.querySelectorAll('.doors door-option')).forEach(el => el.classList.remove('selected'));
            this.classList.add('selected');

            const door = event.currentTarget;
            const order = door.dataset.order;
            const value = door.dataset.value;




            selectedDoor = door;

            //console.log('selected door:', door);


            //const doorType = door.dataset.doorType;
            //const doorInsert = door.dataset.doorInsert;
            //console.log('doorType:', doorType);
            //console.log('doorInsert:', doorInsert);


            isDoorTouched = true;




            //console.log('target element:', event.target.classList.contains('mini-door'));





            //const targetElement = event.target.classList.contains('mini-door') ? event.target : event.target.closest('.door-option');

            if (doors[order]) {
                let currentDoor = doors[order];
                const currentClass = currentDoor.className.replace('door ', '');

                // reset the selected options for door type, vinyl and colonial
                Array.from(document.querySelectorAll(`select-image-option[data-name~='doorType'], select-image-option[data-name~='doorVinylOption'], select-image-option[data-name~='doorColonialOption']`)).forEach(el => el.classList.remove('selected'));

                // set the selected options for doortype, vinyl, gyprock and colonial
                if (['mirror', 'paintedglass', 'gyprock'].includes(currentClass)) {
                    document.querySelector(`select-image-option[data-name~='doorType'][data-value~='${currentClass}']`).classList.add('selected');
                    document.querySelector('#doortype-colonial-options').classList.add('d-none');
                    document.querySelector('#doortype-vinyl-options').classList.add('d-none');
                } else if (VINYL_OPTIONS.includes(currentClass)) {
                    document.querySelector(`select-image-option[data-name~='doorType'][data-value~='vinyl']`).classList.add('selected');
                    document.querySelector(`select-image-option[data-name~='doorVinylOption'][data-value~='${currentClass}']`).classList.add('selected');
                    document.querySelector('#doortype-vinyl-options').classList.remove('d-none');
                    document.querySelector('#doortype-colonial-options').classList.add('d-none');
                } else if (COLONIAL_OPTIONS.includes(currentClass)) {
                    document.querySelector(`select-image-option[data-name~='doorType'][data-value~='colonial']`).classList.add('selected');
                    document.querySelector(`select-image-option[data-name~='doorColonialOption'][data-value~='${currentClass}']`).classList.add('selected');
                    document.querySelector('#doortype-colonial-options').classList.remove('d-none');
                    document.querySelector('#doortype-vinyl-options').classList.add('d-none');
                }
            }
            doors[order] = door;
        });
    }
}
customElements.define('door-option', SelectedDoorOptionSelector);

window.addEventListener('load', () => {
    console.log('sm-door-designer-v2-doors.js is loaded');

    addModal('door');
    addLabelClickListeners();

    $('.door').on('click', () => {
        const focusDiv = document.getElementById('group-doors-types');
        focusDiv.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Scroll to the top of the div
        });
    });
});


const addModal = (className) => {
    const openModalButtons = document.querySelectorAll(`.frame .doors:not(.mini-doors) .${className}`);
    const closeModalButtons = document.querySelectorAll('.btn-close');
    const modal = document.querySelector('#myModal');

    openModalButtons.forEach(openModalBtn => {
        openModalBtn.addEventListener('click', function () {
            modal.classList.remove('hidden');

            console.log('modal: ', $(openModalBtn), $(modal));

            console.log('data-type: ', 
                $(openModalBtn).attr('data-type'), 
                '\ndata-value: ', $(openModalBtn).attr('data-door-insert'));

            const doorType = $(openModalBtn).attr('data-door-type');
            const doorValue = $(openModalBtn).attr('data-door-insert');

            $(modal).find('#insertOptionsContainer .option').each(function() {
                $(this).removeClass('active');
            });
            $(modal).find('#insertOptionsContainer .sBtn-text').text(doorValue);
            $(modal).find('#insertOptionsContainer .option[data-door-type="'+doorType+'"][data-door-insert="'+doorValue+'"]').addClass('active');


            if (doorType.trim() !== 'doorType') {
                $(modal).find('#insertOptionsContainer .option[data-door-type="'+doorType+'"][data-door-insert="'+doorValue+'"]').closest('.child-options').addClass('active');
            } else {
                $(modal).find('#insertOptionsContainer .child-options').removeClass('active');
            }


            // // Access the checkbox element
            // const addFloorBattenCheckbox = document.getElementById('applyToAllDoors_option');

            // // Check if the checkbox is checked
            // if (addFloorBattenCheckbox.checked) {
            //     // If checked, get the value
            //     const value = addFloorBattenCheckbox.value;
            //     console.log('Checkbox value:', value);

            //     document.getElementById('applyToAllDoors').classList.remove('d-none');
            //     document.getElementById('applyToSelectedDoor').classList.add('d-none');
            //     document.getElementById('applyToSelectedDoor_helpText').classList.remove('d-none');
            //     document.getElementById('applyToAllDoors_helpText').classList.add('d-none');
            // } else {
            //     console.log('Checkbox is not checked');
            //     document.getElementById('applyToAllDoors').classList.add('d-none');
            //     document.getElementById('applyToSelectedDoor').classList.remove('d-none');
            //     document.getElementById('applyToSelectedDoor_helpText').classList.add('d-none');
            //     document.getElementById('applyToAllDoors_helpText').classList.remove('d-none');
            // }
        });
    });

    const closeModal = () => {
        modal.classList.add('hidden');

        $(modal).find('#insertOptionsContainer .select-menu').removeClass('active');


        // this will hide the selected class from the door (dashed boarder)
        // setTimeout(() => {
        //     document.querySelectorAll('.door').forEach(door => door.classList.remove('selected'));
        // }, 500);
    };
    
    closeModalButtons.forEach(btn => {
        btn.addEventListener('click', closeModal);
    });
    
    window.addEventListener('click', event => {
        if (event.target === modal) {
            closeModal();
        }
    });

    $('#applyToAllDoors').on('click', function () {
        var insertCategory = $('#insertOptionsContainer .select-menu').attr('data-value');
        const element = $('door-option');

        let className = insertCategory;
        element.attr('data-type', 'doorType');
        element.attr('data-value', className);

        if (insertCategory === 'vinyl') {
            var selectedVinyl = $('#vinylOptionsContainer .select-menu').attr('data-value');
            selectedVinyl = selectedVinyl === 'glacier / white' ? 'glacier' : selectedVinyl;
            className += ' ' + selectedVinyl;
            element.attr('data-type', insertCategory);
            element.attr('data-value', selectedVinyl);

        } else if (insertCategory === 'colonial') {
            var selectedColonial = $('#colonialOptionsContainer .select-menu').attr('data-value');
            className += ' ' + selectedColonial;
            element.attr('data-type', insertCategory);
            element.attr('data-value', selectedColonial);
        }

        className = className?.toLowerCase();

        clearInserts(element);
        element.addClass(className);
        document.querySelectorAll('.door').forEach(door => door.classList.remove('selected'));
        getPricingEstimates();
    });

    $('#applyToSelectedDoor').on('click', function () {
        const doorType = $('#insertOptionsContainer .select-menu').attr('data-door-type');
        const insertMaterial = $('#insertOptionsContainer .select-menu').attr('data-door-insert');

        applyToSelectedDoorOnly(doorType, insertMaterial);


        // var insertCategory = $('#insertOptionsContainer .select-menu').attr('data-value');
        // console.log('applying to selected door only', insertCategory);
        // const element = $('door-option.selected');

        // let className = insertCategory;
        // element.attr('data-type', 'doorType');
        // element.attr('data-value', className);

        // if (insertCategory === 'vinyl') {
        //     var selectedVinyl = $('#vinylOptionsContainer .select-menu').attr('data-value');
        //     selectedVinyl = selectedVinyl === 'glacier / white' ? 'glacier' : selectedVinyl;
        //     className += ' ' + selectedVinyl;
        //     element.attr('data-type', insertCategory);
        //     element.attr('data-value', selectedVinyl);

        // } else if (insertCategory === 'colonial') {
        //     var selectedColonial = $('#colonialOptionsContainer .select-menu').attr('data-value');
        //     className += ' ' + selectedColonial;
        //     element.attr('data-type', insertCategory);
        //     element.attr('data-value', selectedColonial);
        // }

        // className = className?.toLowerCase();

        // clearInserts(element);
        // element.addClass(className);
        
        // document.querySelectorAll('.door, .mini-door').forEach(door => door.classList.remove('selected'));

        // getPricingEstimates();
    });
}

const clearInserts = (element) => {
    // $(element).removeClass(
    //     INSERTS.join(' ') + ' ' + 
    //     VINYL_OPTIONS.join(' ') + ' ' + 
    //     COLONIAL_OPTIONS.join(' ')
    //     );

    // remove all classes from the element
    $(element).removeClass();
    $(element).addClass('door');

    // $(element).removeClass(
    //     INSERTS.join(' ') + ' ' + 
    //     VINYL_OPTIONS.join(' ') + ' ' + 
    //     COLONIAL_OPTIONS.join(' ')
    //     );
};

const addLabelClickListeners = () => {
    document.getElementById('left-height-label').addEventListener('click', () => {
        document.getElementById('customLeftHeight').focus();
    });

    document.getElementById('right-height-label').addEventListener('click', () => {
        document.getElementById('customRightHeight').focus();
    });

    document.getElementById('top-width-label').addEventListener('click', () => {
        document.getElementById('customTopWidth').focus();
    });

    document.getElementById('bottom-width-label').addEventListener('click', () => {
        document.getElementById('customBottomWidth').focus();
    });

    document.querySelector('.preview-title').addEventListener('click', function () {
        document.getElementById('setName').scrollIntoView({ behavior: 'smooth' });
        document.getElementById('setName').focus();
    });

    document.getElementById('setName').addEventListener('input', (event) => {
        const previewTitle = document.querySelector('.preview-title h1');
        previewTitle.textContent = event.target.value ? event.target.value.toUpperCase() : 'DOOR PREVIEW';
    });
};

document.getElementById('setName').addEventListener('click', function () {
    var elements = document.querySelectorAll('.preview-title');
    elements.forEach(function(element) {
        element.classList.add('active');
    });
});

document.getElementById('setName').addEventListener('blur', function () {
    var elements = document.querySelectorAll('.preview-title');
    elements.forEach(function(element) {
        element.classList.remove('active');
    });
});


